// interfaces are a typescript feature that allows you to define a contract that other classes can implement
// however, when transcompiled to native javascript they are removed, meaning we cant really type check them
// like we would normally do for a compiled language
// this is why we have to use a function to check if an object is an instance of an interface
export const isSerializable = (item: any) => {
    return item?.iSerializable === true && typeof item.serialize === 'function'
}

export interface ISerializable {
    iSerializable: true
    serialize(): any
    deserialize(obj: any): void
}
